export default __webpack_public_path__ + "static/media/shield_green.bcd14ea6.svg";